<div class="col-md-3">
  <button (click)="checkout(priceId)" class="btn btn-primary btn-block btn-lg"><i class="fa fa-lock" aria-hidden="true"></i>&nbsp;&nbsp;{{checkoutText}}</button>
</div>


